import { API_URL } from "../../../utils/config";

export const GET_WEB_COUNT_URL = `${API_URL}/link-count/getLinkCount/web`;
export const GET_ANDROID_COUNT_URL = `${API_URL}/link-count/getLinkCount/android`;
export const GET_IOS_COUNT_URL = `${API_URL}/link-count/getLinkCount/ios`;